import { Calculate } from './Calculate';

const calculate = new Calculate();
export interface AnalyticsData {
    totalAncillary: number;
    totalAncillaryPremium: number;
    totalMajorMed: number;
    totalPrivateMed: number;
    totalPrivateMedPremium: number;
    totalCost: number;
    totalCalls: number; 
    totalBillable: number;
  }


  export class Analytics {
    private data: AnalyticsData;
  
    constructor(data: AnalyticsData) {
      this.data = data;
    }
  
    /**
     * Returns the total sales, calculated as the sum of the ancillary
     * and private med premiums. Adjust this logic as needed.
     */
    totalSales(): number {
      return  this.data.totalMajorMed + this.data.totalPrivateMed;
    }

    totalCost(): number {
        return this.data.totalCost;
    }
    totalCalls(): number {
        return this.data.totalCalls;
    }
    totalBillable(): number {
        return this.data.totalBillable;
    }

    totalMajorMed(): number {
        return this.data.totalMajorMed;
    }
    totalPrivateMed(): number {
        return this.data.totalPrivateMed; 
    }
    totalAncillary(): number {
        return this.data.totalAncillary;
    }
    totalAncillaryPremium(): number {
        return this.data.totalAncillaryPremium;
    }
    totalPrivateMedPremium(): number {
        return this.data.totalPrivateMedPremium;
    }
    /**
     * Returns the total premium, calculated as the sum of the ancillary
     * and private med premiums. Adjust this logic as needed.
     */
    totalPremiumA(): number {
      return this.data.totalAncillaryPremium + this.data.totalPrivateMedPremium;
  } 
    
    totalPremiumB(): number {
        return this.data.totalAncillaryPremium + this.data.totalPrivateMedPremium + (this.data.totalMajorMed*50);
        }
  
  cpaA(): number {
    return calculate.cpa(this.data.totalCost, this.data.totalPrivateMed);
  }

  cpaB(): number {
    return calculate.cpa(this.data.totalCost, (this.data.totalPrivateMed + this.data.totalMajorMed));
  }
  
  ptcA(): number {
    const totalPremium = this.totalPremiumA();
    const totalCost = this.data.totalCost;
    return calculate.ratio(totalPremium, totalCost);
  }

    ptcB(): number {
       
        const totalPremium = this.totalPremiumB() ;
        const totalCost = this.data.totalCost;
        return calculate.ratio(totalPremium, totalCost);
    }

  ap(): number {
     return calculate.ratio(this.data.totalPrivateMedPremium, this.data.totalPrivateMed);
  }
  siaScore(): number {
    const score = this.ptcA() * this.totalSales();
    return score;
  } 

  billRate(): number {
    const billRate= calculate.percentage(this.data.totalBillable, this.data.totalCalls);
    return Math.round(billRate);
  }
  
  cr(): number {
    const leads = this.data.totalBillable;
    const sales = this.totalSales();
    return calculate.percentage(sales,leads );
  }

  cpc():number{
    const cpc = this.data.totalCost / this.data.totalCalls ;
    return cpc > 0 ? cpc : 0;
    
  }
}